import { Log } from 'probe.gl';
export const log = new Log({
  id: 'luma.gl'
});
//# sourceMappingURL=log.js.map